import React from "react";
import Report from "../report/report";
import {Utils} from "../../../helpers/utils";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {IPaginationStore} from "../../../common/stores/paginationStore";
import {storesContext} from "../../../common/stores/stores";
import i18n from "../../../i18n/i18n";
import {TransportRegisterService} from "../../services/transportRegisterService";
import DropDown from "../../../common/components/shared/dropDown/dropDown";
import {ValidatedValue} from "../../../helpers/validatedValue";
import {DropDownModel} from "../../../common/models/dropDown";
import {ShipownerModel} from "../../../dictionaries/models/shipowners";
import {FerryDropDownModel} from "../../../dictionaries/models/ferry";
import {ShipownerService} from "../../../dictionaries/services/shipownerService";
import {FerryService} from "../../../dictionaries/services/ferryService";
import DateTimePicker from "../../../common/components/shared/dateTimePicker/dateTimePicker";
import "./transportRegister.scss";
import Validator from "../../../helpers/validator";
import {TransportRegisterModel, TransportRegisterFilters} from "../../models/transportRegister";
import {DateUtils} from "../../../helpers/dateUtils";
import {DropDownUtils} from "../../../helpers/dropDownUtils";
import {WharfsModel} from "../../../topology/models/wharf";
import {WharfService} from "../../../topology/services/wharfService";
import {PortModel} from "../../../dictionaries/models/ports";
import {PortService} from "../../../dictionaries/services/portService";
import {TimetableActionTypes} from "../../../timetables/models/timetable";
import { Api } from "../../../helpers/api";
import Loader from "../../../common/components/shared/loader/loader";

interface TransportRegisterState {
    selectedShipowner: ValidatedValue<string>;
    selectedFerry: ValidatedValue<string>;
    selectedArrivalFerryFrom: ValidatedValue<Date | null>;
    selectedArrivalFerryTo: ValidatedValue<Date | null>;
    selectedDepartureFerryFrom: ValidatedValue<Date | null>;
    selectedDepartureFerryTo: ValidatedValue<Date | null>;
    selectedWharf: ValidatedValue<string>;
    selectedOriginDestinationPort: ValidatedValue<string>;
    selectedActionType: ValidatedValue<string>;
    isSubmitButtonBlocked: boolean;
    isReportGenerated: boolean;
    generatedReport: TransportRegisterModel[] | undefined | null;
    generatedReportResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    currentPage: number;
    shipowners: ShipownerModel[];
    ferries: FerryDropDownModel[];
    wharfs: WharfsModel;
    ports: PortModel[];
    ferriesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    shipownersResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    wharfsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    portsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default class TransportRegister extends React.Component <any, TransportRegisterState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            selectedShipowner: new ValidatedValue(""),
            selectedFerry: new ValidatedValue(""),
            selectedArrivalFerryFrom: new ValidatedValue(null),
            selectedArrivalFerryTo: new ValidatedValue(null),
            selectedDepartureFerryFrom: new ValidatedValue(null),
            selectedDepartureFerryTo: new ValidatedValue(null),
            selectedWharf: new ValidatedValue(""),
            selectedOriginDestinationPort: new ValidatedValue(""),
            selectedActionType: new ValidatedValue(""),
            isSubmitButtonBlocked: false,
            isReportGenerated: false,
            generatedReport: undefined,
            generatedReportResponse: undefined,
            currentPage: 0,
            shipowners: [],
            ferries: [],
            wharfs: {wharfs: []},
            ports: [],
            ferriesResponse: undefined,
            shipownersResponse: undefined,
            portsResponse: undefined,
            wharfsResponse: undefined
        };

        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
    }

    async componentDidMount() {
        await  this.getFerries();
        await  this.getWharfs();
        await  this.getShipowners();
        await  this.getPorts();
    }

    public render(): JSX.Element {
        const properties = ["ferryName", "shipownerName", "directionType", "voyageNo", "arrivalDepartureTime", "wharf",
            "originDestinationPort", "numberOfLorryTrailers", "numberOfTrailers", "numberOfCars", "numberOfBuses",
            "numberOfRailways", "numberOfGeneralCargos", "numberOfContainers", "vgmSum", "numberOfOthers"];
        const headers = properties.map(key => i18n.t("reports.transportRegister.headers." + key));
        const isDataLoadedOrDataLoadError = (this.state.shipowners.length > 0 && this.state.ferries.length > 0 && this.state.wharfs.wharfs && this.state.wharfs.wharfs.length > 0 && this.state.ports.length > 0) ||
            !Api.isSuccess(this.state.shipownersResponse) || !Api.isSuccess(this.state.ferriesResponse) || !Api.isSuccess(this.state.wharfsResponse) || !Api.isSuccess(this.state.portsResponse);

        if (isDataLoadedOrDataLoadError) {
            return (
                <Report
                    className="transport-register"
                    filters={this.renderFilters()}
                    onGenerateReport={this.onGenerateReport.bind(this)}
                    generatedReport={this.state.generatedReport}
                    generatedReportResponse={this.state.generatedReportResponse}
                    isReportGenerated={this.state.isReportGenerated}
                    reportTestId="transport-register"
                    reportProperties={properties}
                    reportHeaders={headers}
                    reportTableRenderCell={this.renderCell}
                    currentPage={this.state.currentPage}
                    reportService={TransportRegisterService}
                    isSummaryReportGenerated={false}
                    selectedFilters={
                        {
                            arrivalFerryFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedArrivalFerryFrom.value),
                            arrivalFerryTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedArrivalFerryTo.value),
                            departureFerryFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepartureFerryFrom.value),
                            departureFerryTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepartureFerryTo.value),
                            ferryEntityId: this.state.selectedFerry.value,
                            shipownerEntityId: this.state.selectedShipowner.value,
                            wharfId: this.state.selectedWharf.value,
                            originDestinationPortId: this.state.selectedOriginDestinationPort.value,
                            actionType: this.state.selectedActionType.value
                        } as TransportRegisterFilters
                    }
                    isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                    summaryCurrentPage={0}
                    summaryNumberOfElements={0}
                />
            );
        } else {
            return <Loader/>;
        }
    }

    private renderFilters(): JSX.Element {
        return (
            <>
                <DateTimePicker
                    label={i18n.t("reports.transportRegister.filters.arrivalFerryFrom")}
                    validatedValue={this.state.selectedArrivalFerryFrom}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedArrivalFerryFrom.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedArrivalFerryFrom, this.state.selectedArrivalFerryTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
                    }}
                    testId="filters-arrival-ferry-from"
                />
                <DateTimePicker
                    label={i18n.t("reports.transportRegister.filters.arrivalFerryTo")}
                    validatedValue={this.state.selectedArrivalFerryTo}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedArrivalFerryTo.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedArrivalFerryFrom, this.state.selectedArrivalFerryTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
                    }}
                    testId="filters-arrival-ferry-to"
                />
                <DateTimePicker
                    label={i18n.t("reports.transportRegister.filters.departureFerryFrom")}
                    validatedValue={this.state.selectedDepartureFerryFrom}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedDepartureFerryFrom.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedDepartureFerryFrom, this.state.selectedDepartureFerryTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
                    }}
                    testId="filters-departure-ferry-from"
                />
                <DateTimePicker
                    label={i18n.t("reports.transportRegister.filters.departureFerryTo")}
                    validatedValue={this.state.selectedDepartureFerryTo}
                    onChange={(newDate: Date | null) => {
                        this.state.selectedDepartureFerryTo.setValue(newDate);
                        Validator.addValidatorsToDateTimePicker(this.state.selectedDepartureFerryFrom, this.state.selectedDepartureFerryTo);
                        Validator.addOneDateRequiredValidator(this.state.selectedArrivalFerryFrom, this.state.selectedDepartureFerryFrom);
                    }}
                    testId="filters-departure-ferry-to"
                />
                <DropDown
                    label={i18n.t("reports.transportRegister.filters.shipowner")}
                    items={this.shipownerToDropDownMap}
                    validatedValue={this.state.selectedShipowner}
                    testId="filters-shipowner"
                    withEmptyValue
                    error={!Api.isSuccess(this.state.shipownersResponse) ? i18n.t("errorMessages.shipownersErrorSuffix") : ""}
                    reloadFunc={() => this.getShipowners()}
                    isNoRequired
                />
                <DropDown
                    label={i18n.t("reports.transportRegister.filters.ferry")}
                    items={this.ferryToDropDownMap}
                    validatedValue={this.state.selectedFerry}
                    testId="filters-ferry"
                    withEmptyValue
                    error={!Api.isSuccess(this.state.ferriesResponse) ? i18n.t("errorMessages.ferriesErrorSuffix") : ""}
                    reloadFunc={() => this.getFerries()}
                    isNoRequired
                />
                <DropDown
                    label={i18n.t("reports.transportRegister.filters.wharf")}
                    items={this.wharfsToDropDownMap()}
                    validatedValue={this.state.selectedWharf}
                    testId="filters-wharf"
                    withEmptyValue
                    withoutSort
                    error={!Api.isSuccess(this.state.wharfsResponse) ? i18n.t("errorMessages.wharfsErrorSuffix") : ""}
                    reloadFunc={() => this.getWharfs()}
                    isNoRequired
                />
                <DropDown
                    label={i18n.t("reports.transportRegister.filters.originDestinationPort")}
                    items={this.originDestinationPortToDropdown()}
                    validatedValue={this.state.selectedOriginDestinationPort}
                    testId="filters-origin-destination-port"
                    withEmptyValue
                    error={!Api.isSuccess(this.state.portsResponse) ? i18n.t("errorMessages.portsErrorSuffix") : ""}
                    reloadFunc={() => this.getPorts()}
                    isNoRequired
                />
                <DropDown
                    label={i18n.t("reports.transportRegister.filters.actionType")}
                    items={this.actionTypeToDropDownMap}
                    validatedValue={this.state.selectedActionType}
                    testId="filters-action-type"
                    withEmptyValue
                />
            </>
        );
    }

    private renderCell(row: any, property: string): JSX.Element {
        switch (property) {
            case "directionType":
                return <>{i18n.t(`directionType.${row[property]}`)}</>;
            case "arrivalDepartureTime":
                return <>{DateUtils.getFormattedDateWithTime((row[property]))}</>;
            default:
                return row[property];
        }
    }

    private get shipownerToDropDownMap(): DropDownModel[] {
        return DropDownUtils.listToDropDownMap(this.state.shipowners, "entityId");
    }

    private get ferryToDropDownMap(): DropDownModel[] {
        return DropDownUtils.listToDropDownMap(this.state.ferries, "entityId");
    }

    private wharfsToDropDownMap(): DropDownModel[] {
        if (!this.state.wharfs || !this.state.wharfs.wharfs || !this.state.wharfs.wharfs.length) {
            return [];
        }

        return DropDownUtils.listToDropDownMap(this.state.wharfs.wharfs);
    }

    private originDestinationPortToDropdown() {
        return DropDownUtils.listToDropDownMap(this.state.ports);
    }

    private get actionTypeToDropDownMap(): DropDownModel[] {
        return [
            {
                id: TimetableActionTypes.ARRIVAL,
                name: i18n.t("directionType.ARRIVAL"),
            },
            {
                id: TimetableActionTypes.DEPARTURE,
                name: i18n.t("directionType.DEPARTURE"),
            }
        ];
    }

    private get isValid(): boolean {
        this.state.selectedArrivalFerryFrom.validate();
        this.state.selectedArrivalFerryTo.validate();
        this.state.selectedDepartureFerryFrom.validate();
        this.state.selectedDepartureFerryTo.validate();
        this.state.selectedFerry.validate();
        this.state.selectedShipowner.validate();
        this.state.selectedWharf.validate();
        this.state.selectedOriginDestinationPort.validate();
        this.state.selectedActionType.validate();

        return this.state.selectedArrivalFerryFrom.isValid && this.state.selectedArrivalFerryTo.isValid
        && this.state.selectedDepartureFerryFrom.isValid && this.state.selectedDepartureFerryTo.isValid
        && this.state.selectedFerry.isValid && this.state.selectedShipowner.isValid
        && this.state.selectedWharf.isValid && this.state.selectedOriginDestinationPort.isValid && this.state.selectedActionType.isValid;
    }

    private async onGenerateReport() {
        this.setState({generatedReportResponse: undefined});
        const paginationStore = this.context.paginationStore as IPaginationStore;

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});

            const filters = {
                arrivalFerryFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedArrivalFerryFrom.value),
                arrivalFerryTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedArrivalFerryTo.value),
                departureFerryFrom: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepartureFerryFrom.value),
                departureFerryTo: DateUtils.getFormattedDateWithTimeInUTC(this.state.selectedDepartureFerryTo.value),
                ferryEntityId : this.state.selectedFerry.value,
                shipownerEntityId: this.state.selectedShipowner.value,
                wharfId: this.state.selectedWharf.value,
                originDestinationPortId: this.state.selectedOriginDestinationPort.value,
                actionType: this.state.selectedActionType.value
            };

            const generatedReportResponse = await TransportRegisterService.generateReport(
                filters
            );

            this.setState({
                isSubmitButtonBlocked: false,
                generatedReportResponse,
                generatedReport: generatedReportResponse?.data?.data || null,
                isReportGenerated: true,
                currentPage: generatedReportResponse?.data?.currentPage
            });

            paginationStore.setNumberOfElements(generatedReportResponse?.data?.numberOfElements);
            paginationStore.setNumberOfPages(generatedReportResponse?.data?.numberOfPages);
        }

        Utils.scrollToFirstErrorMessage();
    }

    private async getFerries() {
        const ferriesResponse = await FerryService.getFerriesForDropDown();

        this.setState({
            ferries: (ferriesResponse)?.data || [],
            ferriesResponse,
        });
    }

    private async getShipowners() {
        const shipownersResponse = await ShipownerService.getAll();

        this.setState({
            shipowners: (shipownersResponse)?.data?.data || [],
            shipownersResponse
        });
    }

    private async getWharfs() {
        const wharfsResponse = await WharfService.getAll();

        this.setState({
            wharfs: (wharfsResponse)?.data || [],
            wharfsResponse
        });
    }

    private async getPorts() {
        const portsResponse = await PortService.getAll();

        this.setState({
            ports: (portsResponse)?.data?.data || [],
            portsResponse,
        });
    }
}